export default "__VITE_ASSET__BSV3dN9E__"